import { ContractType } from "./../../contracts/contract-form/contract-form.component";
import {
  DxButtonModule,
  DxDataGridComponent,
  DxDataGridModule,
} from "devextreme-angular";
import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ContractConfigService } from "src/app/services/contracts/contract-config.service";
import { AppGlobals } from "src/app/app.globals";
import { confirm, custom } from "devextreme/ui/dialog";
import { async } from "rxjs";
import { EditingTexts } from "devextreme/ui/data_grid";

import { SvgIconComponent } from "src/app/components/svg-icon/svg-icon.component";
import { GpdButtonComponent } from "src/app/components/gpd-button/gpd-button.component";
@Component({
    selector: "app-config-contracts.page",
    imports: [
    GpdButtonComponent,
    SvgIconComponent,CommonModule, DxDataGridModule, DxButtonModule],
    templateUrl: "./config-contracts.page.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./config-contracts.page.component.css"]
})
export class ConfigContractsPageComponent implements OnInit {

  
  @ViewChild("contractTypesGrid", { static: false })
  contractTypesGrid: DxDataGridComponent;
  @ViewChild("deadlineTypesGrid", { static: false })
  deadlineTypesGrid: DxDataGridComponent;

  contractTypes: ContractType[] = [];
  deadlineTypes: any = [];
  userPermissions: any = AppGlobals.UserPermissions;

  newId = 0;
  deletePopup: any;

  editText: EditingTexts = {
    cancelRowChanges: $localize`:@@cancel: Cancel`,
    saveRowChanges: $localize`:@@save: Save`,
  };

  constructor(private contractConfigService: ContractConfigService) {
    this.validateContractTypeDuplicateName =
      this.validateContractTypeDuplicateName.bind(this);
    this.validateDeadlineTypeDuplicateName =
      this.validateDeadlineTypeDuplicateName.bind(this);
  }

  ngOnInit(): void {
    this.contractConfigService.getContractConfig({});
    this.contractConfigService.contractTypes$.subscribe((response: any) => {
      this.contractTypes = response;
    });

    this.contractConfigService.getContractDeadlineTypes({});
    this.contractConfigService.deadlineType$.subscribe((response: any) => {
      this.deadlineTypes = response;
    });
  }

  addNewContractType() {
    this.contractTypesGrid.instance.addRow();
  }

  editContractType(id: any) {
    let visibleRows = this.contractTypesGrid.instance.getVisibleRows();

    let index = null;

    visibleRows.some((row: any) => {
      console.log("Row: ", row);
      if (row.data.id === id) {
        index = row.rowIndex;
        console.log("Index: ", index);
        return true;
      }
    });

    this.contractTypesGrid.instance.editRow(index);
  }

  getNewId() {
    this.newId = this.newId - 1;
    return this.newId;
  }

  async saveContractType(e: any) {
    const change = e.changes[0];
    const changedEntry = this.contractTypes.find(
      (contractType: any) => contractType.id === change.key.id
    );

    const payload = {
      id: changedEntry?.id ?? this.getNewId(),
      name: change.data.name ?? changedEntry?.name,
    };

    await this.contractConfigService.saveContractType({
      ContractType: payload,
    });
    await this.contractConfigService.getContractConfig({});
  }

  deleteContractType(itemToDelete: any) {
    let deleteDialog = custom({
      title: $localize`:@@confirmDeletionTitle:Confirm deletion`,
      messageHtml:
        "<i>" +
        $localize`:@@confirmDeletionItemMessage:Do you want to delete this item?` +
        "</i>",
      buttons: [
        { text: $localize`:@@yes:Yes`, onClick: () => true },
        { text: $localize`:@@no:No`, onClick: () => false },
      ],
    });

    deleteDialog.show().done((dialogResult) => {
      if (dialogResult) {
        let payload = {
          id: itemToDelete.id,
        };
        this.contractConfigService.deleteContractType({
          ContractType: payload,
        });
      }
    });
  }

  /************* Deadlines *************/

  addNewDeadlineType() {
    this.deadlineTypesGrid.instance.addRow();
  }

  editDeadlineType(arg0: any) {
    let visibleRows = this.deadlineTypesGrid.instance.getVisibleRows();

    let index = null;

    visibleRows.some((row: any) => {
      console.log("Row: ", row);
      if (row.data.id === arg0) {
        index = row.rowIndex;
        console.log("Index: ", index);
        return true;
      }
    });

    this.deadlineTypesGrid.instance.editRow(index);
  }

  async saveDeadlineType($event: any) {
    let changedEntry = null;

    this.deadlineTypes.find((deadlineType: any) => {
      if (deadlineType.id === $event.changes[0].key) {
        changedEntry = deadlineType;
      }
    });

    let payload = {
      id: changedEntry?.id ?? this.getNewId(),
      name: $event.changes[0].data.name ?? changedEntry.name,
    };

    await this.contractConfigService.saveContractDeadlineType({
      ContractDeadlineType: payload,
    });
    await this.contractConfigService.getContractDeadlineTypes({});
  }

  deleteDeadlineType(itemToDelete: any) {
    let deleteDialog = custom({
      title: $localize`:@@confirmDeletionTitle:Confirm deletion`,
      messageHtml:
        "<i>" +
        $localize`:@@confirmDeletionItemMessage:Do you want to delete this item?` +
        "</i>",
      buttons: [
        { text: $localize`:@@yes:Yes`, onClick: () => true },
        { text: $localize`:@@no:No`, onClick: () => false },
      ],
    });
    deleteDialog.show().done((dialogResult) => {
      if (dialogResult) {
        let payload = {
          id: itemToDelete.id,
        };
        this.contractConfigService.deleteContractDeadlineType({
          ContractDeadlineType: payload,
        });
      }
    });
  }

  validateContractTypeDuplicateName(e) {
    const contractTypeExists = this.contractTypes.some(
      (contractType: any) => contractType.name == e.value
    );
    return !contractTypeExists;
  }

  validateDeadlineTypeDuplicateName(e) {
    const deadlineTypeExists = this.deadlineTypes.some(
      (deadlineType: any) => deadlineType.name == e.value
    );
    return !deadlineTypeExists;
  }
}
